/**
 * Obsługa animacji myszeczki (ikonka przewijania)
 */

export function initMyszeczki() {
  const myszeczki = document.querySelectorAll('.myszeczka');
  if (!myszeczki.length) {
    console.warn('⚠️ Nie znaleziono żadnej .myszeczka w dokumencie.');
    return; // kończymy funkcję — nic do obserwowania
  }

  myszeczki.forEach(myszeczka => {
    const sekcja = myszeczka.closest('section, .section');
    if (!sekcja) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        myszeczka.classList.toggle('myszeczka--ukryta', !entry.isIntersecting);
      });
    }, { threshold: 1 });

    observer.observe(sekcja);

    // Sekcja z wewnetrznym przewijaniem (sticky-section): myszeczka znika, gdy
    // doscrollowano do konca, bo nie ma juz co przewijac.
    const stickyContent = sekcja.querySelector('.sticky-content');
    if (stickyContent) {
      const sprawdzKoniec = () => {
        const koniec = stickyContent.scrollTop >= stickyContent.scrollHeight - stickyContent.clientHeight - 2;
        myszeczka.classList.toggle('myszeczka--koniec', koniec);
      };
      stickyContent.addEventListener('scroll', sprawdzKoniec, { passive: true });
      sprawdzKoniec();
    }
  });

}